import React from 'react';
import './Header.css';
import Menu from './Menu/Menu.jsx';
import Logo from '../../img/logo.svg';

const Header = (props) => {
return (
    <header className='container_header'>
        <div>
            <a href='#'>
                <img src={Logo} alt="Logotype" />
            </a>
        </div>
        <Menu />
        <div></div>
    </header>
);
}

export default Header;